import { PAGSEGURO_MERCHANT_KEYS, PAGSEGURO_MERCHANT_QUERY_PARAM } from 'credit-cards/pagseguro/constants'

export const getPagseguroPublicKey = merchantId => {
    const merchantFromQuery = new URLSearchParams(window.location.search).get(PAGSEGURO_MERCHANT_QUERY_PARAM)
    const merchant = merchantId || merchantFromQuery
    const pagseguroPublicKey = PAGSEGURO_MERCHANT_KEYS[merchant]

    return pagseguroPublicKey || window.PAGSEGURO_KEY
}
